module.exports = __webpack_public_path__ + "media/images/features/modification/eyecatch-question-sm-0cb735c08f52e3524d477e9d351d0c30.png";